import React from 'react'
import './freec.css'
import htmlpix from './books/tutorialpoint.png';
import htmlfile from './books/html_tutorial.pdf';
import javascriptpix from './books/javascriptpix.jpg';
import javascript from './books/javascript_tutorial.pdf';
import reactpix from './books/react.png';
import reactfile from './books/react.pdf';
import nodepix from './books/node.png';
import nodefile from './books/node.pdf';
import pythonpix from './books/python.jpg';
import pythonfile from './books/python.pdf';

const data = [
  {
    name: 'HTML easy learning',
    pix: htmlpix,
    file: htmlfile,
  },
  {
    name: 'Javascript',
    pix: javascriptpix,
    file: javascript,
  },
  {
    name: '30 days of React',
    pix: reactpix,
    file: reactfile,
  },
  {
    name: 'NODEJS',
    pix: nodepix,
    file: nodefile,
  },
  {
    name: 'PYTHON',
    pix: pythonpix,
    file: pythonfile,
  },
];


const Freec = () => {
  return (
    <div>
      <h2>Recommended books</h2>

      <div className="agba">
        {data.map(({ name, pix, file }, index) => {
          return (
            <div key={index} className="fam">
              <div className="imagea">
                <img className="imageee" src={pix} alt="Avatar" />
              </div>
              <div>
                <h5 className="namee">{name}</h5>

                <a href={file} className="dld" target='_blank' rel='noreferrer'>
                  
                  Download pdf
                </a>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default Freec
